import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import App from '../../App.vue';
import router from '../rooters/webSupport';
import store from '../stores/webSupport';
import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';
import globalConfig from '../../resource/utiles/globalConfig';
import '@plugins/replaceAllPolyfills';
globalConfig.setPageTitleAndIco('support page');
setCommonPlugins(Vue);
Vue.config.productionTip = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#webSupport');
